import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { HubMark } from "@/components/work/HubMark";

export function WorkStrip() {
  return (
    <section className="border-t border-border/60 py-16 sm:py-20">
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <div className="grid items-center gap-8 md:grid-cols-[minmax(0,1fr)_minmax(0,300px)]">
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-accent">Work</p>
            <h2 className="mt-3 font-display text-3xl font-bold text-foreground sm:text-4xl">
              Built in Hawaiʻi, for Hawaiʻi.
            </h2>
            <p className="mt-4 text-base leading-relaxed text-foreground/85">
              A statewide intelligence engine and the tools around it.
            </p>
            <Link
              to="/work"
              className="group mt-6 inline-flex items-center gap-2 rounded-md border border-accent/60 px-4 py-2 text-sm font-semibold text-accent transition-colors hover:bg-accent/10"
            >
              See the work <ArrowRight className="h-4 w-4 work-arrow-nudge" />
            </Link>
          </div>

          <div className="flex justify-center md:justify-end">
            <HubMark />
          </div>
        </div>
      </div>
    </section>
  );
}
